import { InputComponent } from 'components/common/Input';
import { ICommonInputContainerProps } from 'components/common/Input/new/types';
import React from 'react';

const EditablePaymentField: React.FC<
  {
    children: any;
    editable: boolean;
  } & ICommonInputContainerProps
> = ({ children, editable, ...props }) => (
  <>
    {!editable && children}
    {editable && (
      <InputComponent className='editable-input' {...props} style={{ marginBottom: 0, paddingRight: '16px' }} />
    )}
  </>
);

export default EditablePaymentField;
